interface LookBackSatisfiedProps {
    requiredLookbackPeriod: number | string | null;
    uploadedLookBackPeriod: number | string | null;
}
export const LookBackSatisfied = ({ requiredLookbackPeriod, uploadedLookBackPeriod }: LookBackSatisfiedProps): boolean => {
    const uploadedNumber = Number(uploadedLookBackPeriod);
    const requiredNumber = Number(requiredLookbackPeriod);
    if (isNaN(uploadedNumber)) {
        return false;
    }

    return uploadedNumber >= (isNaN(requiredNumber) ? 0 : requiredNumber);
}